<template>
  <page-header
    title-ch="校外實習"
    title-en="Off Campus Internship"
  >
    <div class="book first mobile_hide" />
    <div class="book second" />
    <div class="book third" />
    <div class="book fourth mobile_hide" />
  </page-header>
</template>
<script>
import PageHeader from '~components/pages/Header'
export default {
  name: 'OffCampusInternshipHeader',
  components: {
    PageHeader
  }
}
</script>
